import { render, staticRenderFns } from "./ConversionIcon.vue?vue&type=template&id=3818b0aa&scoped=true"
import script from "./ConversionIcon.vue?vue&type=script&lang=js"
export * from "./ConversionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818b0aa",
  null
  
)

export default component.exports